import { gql } from '@apollo/client';

export const RELEASE_KPI_CONFIG_MUTATION = gql`
  mutation ReleaseKpiConfig($id: Int!) {
    p {
      releaseKpiConfig(id: $id) {
        success
        message {
          code
          message
        }
        content {
          id
          status
        }
      }
    }
  }
`;
